export enum DriverTypeEnum {
	Regular = 1,
	Taxi = 2,
	Jeepney = 3,
	Connex = 4
}
